import styled from 'styled-components';

import { Text } from '../../cdl/Text/Text';
import { formatNumber } from '../../common/helpers/formatNumber.helper';
import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';

interface ProgressBarProps {
    progress: number;
}

const ProgressBar = styled(Box)<ProgressBarProps>((props) => ({
    backgroundColor: theme.colors.accent.background,
    height: '100%',
    position: 'absolute',
    top: 0,
    zIndex: theme.zIndex[100],
    width: `${props.progress}%`,
}));

interface VolumeBarProps {
    percentage: number;
    label: string;
    volume: number;
}

export const VolumeBar = ({ percentage, label, volume }: VolumeBarProps) => {
    return (
        <Box
            position="relative"
            width="100%"
            borderRadius={4}
            borderColor={theme.colors.border.muted}
            borderStyle="solid"
            borderWidth="1px"
        >
            <ProgressBar progress={percentage} />
            <Box position="relative" zIndex="200" display="flex" justifyContent="space-between" padding={8} gap={8}>
                <Text variant="small">{label}</Text>
                <Text variant="small" style={{ whiteSpace: 'nowrap' }}>
                    {formatNumber({
                        number: volume,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    })}{' '}
                    L
                </Text>
            </Box>
        </Box>
    );
};
